import React from 'react';
import { useFormatMessage } from 'hooks';

const ActivePositions = ({ initial, activated }) => {
  return (
    <div className="p-2" style={{ maxWidth: '200px' }}>
      {/* title  */}
      <div className="flex justify-between items-center">
        <span className="text-brand-darkBlue text-lg font-semibold">
          {useFormatMessage('Home.activePositions')}
        </span>
        <span className="w-3 h-3 rounded-full bg-brand-green"></span>
      </div>
      {/* card  */}
      <div className="flex items-center justify-center bg-brand-veryLightBlue rounded p-6">
        <div className="text-center">
          <p className="text-5xl text-brand-lightBlue">{activated}</p>
          <p className="text-gray-700 text-xl">
            <span className="text-gray-500 pr-1">
              {useFormatMessage('Home.activePositions.in')}
            </span>
            {initial}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ActivePositions;
